var chunkMapping = {
	"46": [
		20046
	],
	"104": [
		90104
	],
	"202": [
		70202
	],
	"1049": [
		31049
	],
	"1132": [
		91132
	],
	"1987": [
		81987
	],
	"2169": [
		22169
	],
	"2211": [
		12211
	],
	"2757": [
		62757
	],
	"3116": [
		23116
	],
	"3487": [
		73487
	],
	"3920": [
		63920
	],
	"4070": [
		84070
	],
	"4382": [
		24382
	],
	"4430": [
		34430
	],
	"4659": [
		54659
	],
	"5568": [
		15568
	],
	"5659": [
		75659
	],
	"5737": [
		65737
	],
	"5763": [
		75763
	],
	"6711": [
		16711
	],
	"6779": [
		6779
	],
	"7422": [
		7422
	],
	"7998": [
		97998
	],
	"8510": [
		78510
	],
	"9045": [
		82759
	],
	"9106": [
		59106
	],
	"9123": [
		89123
	],
	"9659": [
		79659
	]
};
var idToExternalAndNameMapping = {
	"6779": [
		"default",
		"./RegulatoryBundleList",
		4351
	],
	"7422": [
		"default",
		"./NumberDemand",
		4351
	],
	"12211": [
		"default",
		"./Pages",
		55005
	],
	"15568": [
		"default",
		"./EndCustomersList",
		4351
	],
	"16711": [
		"default",
		"./RegulatoryBundleView",
		4351
	],
	"20046": [
		"default",
		"./EndCustomersAddServices",
		4351
	],
	"22169": [
		"default",
		"./OrderDetailsNew",
		4351
	],
	"23116": [
		"default",
		"./EditBundleSuccess",
		4351
	],
	"24382": [
		"default",
		"./Slices",
		55005
	],
	"31049": [
		"default",
		"./EndCustomersAdd",
		4351
	],
	"34430": [
		"default",
		"./OrderComments",
		4351
	],
	"54659": [
		"default",
		"./LandingPage",
		4351
	],
	"59106": [
		"default",
		"./CountryOverview",
		4351
	],
	"62757": [
		"default",
		"./AddBundle",
		4351
	],
	"63920": [
		"default",
		"./BundleManagementDetails",
		4351
	],
	"65737": [
		"default",
		"./OrderListNew",
		4351
	],
	"70202": [
		"default",
		"./NumberRequest",
		4351
	],
	"73487": [
		"default",
		"./RegulationsView",
		4351
	],
	"75659": [
		"default",
		"./EditEndCustomerDetails",
		4351
	],
	"75763": [
		"default",
		"./EndCustomerDetails",
		4351
	],
	"78510": [
		"default",
		"./Api",
		55005
	],
	"79659": [
		"default",
		"./BuyNumbers",
		4351
	],
	"81987": [
		"default",
		"./BundleManagementSuccess",
		4351
	],
	"82759": [
		"default",
		"./i18n",
		4351
	],
	"84070": [
		"default",
		"./NumbersList",
		4351
	],
	"89123": [
		"default",
		"./CountryManage",
		4351
	],
	"90104": [
		"default",
		"./EditBundle",
		4351
	],
	"91132": [
		"default",
		"./BundlesManagementList",
		4351
	],
	"97998": [
		"default",
		"./Provider",
		4351
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}